import { Component, ChangeDetectionStrategy } from '@angular/core';
import { KnhcPlayerComponent } from '../../../shared/playback/player/player.component';

@Component({
  selector: 'knhc-header',
  templateUrl: 'knhc-header.component.html',
  styleUrl: 'knhc-header.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    KnhcPlayerComponent,
  ]
})
export class KnhcHeaderComponent {

}
